export function MergePermissions(base, other) {
    var result = { ...base };
    for (const route_name in other) {
        var route = result[route_name];
        if (!route) {
            // Not there so just add it
            result[route_name] = other[route_name];
        } else {
            // Warning this code untested...
            route.deny = other[route_name].deny;

            for (const model_name in other[route_name].models) {
                var model = route.models[model_name];
                if (!model) {
                    result.models[model_name] =
                        other[route_name].models[model_name];
                } else {
                    for (const field_name in other[route_name].models[
                        model_name
                    ]) {
                        result.models[model_name][field_name] =
                            other[route_name].models[model_name][field_name];
                    }
                }
            }
        }
    }
    return result;
}
